import { Fragment } from 'react';

import useAthleteUserPurchases from './UseAthleteUserPurchases';

import AthleteUserPurchasesGrid from './AthleteUserPurchasesGrid';
import AthleteUserAdditionalPurchasesGrid from './AthleteUserAdditionalPurchasesGrid';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import Constants from '@usas/ui-web/utils/Constants';

import style from '../../Entry.module.css';
import global from '@usas/ui-web/components/GlobalStyle.module.css';

const AthleteUserPurchasesReadOnly = () => {
  const { orgUnitAthleteEntryPurchaseState, orgUnitAthleteEntryInfoState, errorState, onAdditionalPurchaseValueChanged, onBackClicked, onExitButtonClicked
  } = useAthleteUserPurchases();

  return (
    <Fragment>
      <div className={orgUnitAthleteEntryInfoState.objData.teamOrgUnitName === 'Unattached' ? global.DisplayComponent : global.HideComponent}>
        <div className="row">
          <div className="col-xs-12">
            <Headings.H6>Required Purchases</Headings.H6>
          </div>
          <div className="col-xs-12">
            <AthleteUserPurchasesGrid
              gridData={orgUnitAthleteEntryPurchaseState.objData?.purchaseItem}
              isLoading={orgUnitAthleteEntryPurchaseState.isObjLoading}
            />
          </div>
          {orgUnitAthleteEntryPurchaseState.objData?.additionalPurchase?.length > 0 &&
            <Fragment>
              <div className="col-xs-12 usas-extra-top-margin">
                <Headings.H6>Additional Purchases</Headings.H6>
              </div>
              <div className="col-xs-12">
                <AthleteUserAdditionalPurchasesGrid
                  gridData={orgUnitAthleteEntryPurchaseState.objData?.additionalPurchase}
                  isLoading={orgUnitAthleteEntryPurchaseState.isObjLoading}
                  errorState={errorState}
                  onAdditionalPurchaseValueChanged={onAdditionalPurchaseValueChanged}
                />
              </div>
            </Fragment>}
          <div className={style.FloatRight}>
            <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
              <SecondaryButton onClick={onBackClicked}>Back</SecondaryButton>&nbsp;
              <PrimaryButton onClick={onExitButtonClicked}>Exit</PrimaryButton>
            </div>
          </div>
        </div>
        <PopUpModal
          widthPct={50}
          maxWidth={250}
          title={Constants.LOADING_MSG}
          displayPopUp={orgUnitAthleteEntryPurchaseState.isObjLoading === true}
        />
      </div>
      <div className={orgUnitAthleteEntryInfoState.objData.teamOrgUnitName === 'Unattached' ? global.HideComponent : global.DisplayComponent}>
        <div className={style.FloatRight}>
          <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
            <SecondaryButton onClick={onBackClicked}>Back</SecondaryButton>&nbsp;
            <PrimaryButton onClick={onExitButtonClicked}>Exit</PrimaryButton>
          </div>
        </div>
      </div>
    </Fragment >
  );
};

export default AthleteUserPurchasesReadOnly;